import { supabase } from "@/integrations/supabase/client";

type InvokeOptions = {
    internalSecret?: string | null; // opzionale header x-internal-secret (solo server)
};

export async function invokeEdgeFunction(functionName: string, body: unknown, opts: InvokeOptions = {}) {
    const { internalSecret = null } = opts;

    const headers: Record<string, string> = {};

    // include internal secret only if provided (do NOT hardcode in frontend)
    if (internalSecret) {
        headers["x-internal-secret"] = internalSecret;
    }

    try {
        // Il client Supabase gestisce automaticamente l'Authorization header
        // dalla sessione corrente - non passarlo manualmente
        const res = await supabase.functions.invoke(functionName, { 
            body: body,
            ...(Object.keys(headers).length > 0 && { headers })
        });
        
        if (res.error) {
            console.error(`[invokeEdgeFunction] Error calling ${functionName}:`, res.error);
            throw res.error;
        }
        
        return { data: res.data, error: null };
    } catch (error: any) {
        console.error(`[invokeEdgeFunction] Exception calling ${functionName}:`, error);
        // normalized error object
        return { 
            data: null, 
            error: { 
                message: error.message || String(error), 
                code: error.code || 'UNKNOWN_ERROR',
                original: error 
            } 
        };
    }
}